import React from "react";
import "./../css/devcontact.scss";
import { useLanguage } from "../context/LanguageContext";

function DevContact() {
  const { lang } = useLanguage();

  const title = lang === 'en' ? "ESTABLISHING COMMUNICATION NODES" : "ESTABLECIENDO NODOS DE COMUNICACIÓN";
  const note = lang === 'en' 
    ? "Note: All transmissions are optimized for direct technical exchange. Response latency may vary based on hardware compute cycles."
    : "Nota: Todas las transmisiones están optimizadas para el intercambio técnico directo. La latencia de respuesta puede variar según los ciclos de cómputo del hardware.";

  return (
    <div className="py-2 px-3 dev-contact">
      <div className="framework p-1">
        <h4 className="fw-bold mb-3" style={{ color: '#00ff9d', letterSpacing: '2px' }}>{title}</h4>
        
        <div className="mt-4 contact-grid">
          <p className="mb-2">
            <span className="fw-bold text-info">SOURCE_CODE:</span>{" "}
            <a href="https://github.com/jacobgacosta" target="_blank" rel="noreferrer" className="text-secondary text-decoration-none">github.com/jacobgacosta</a>
          </p>
          <p className="mb-2">
            <span className="fw-bold text-info">PROFESSIONAL_MESH:</span>{" "}
            <a href="https://linkedin.com/in/jgacosta" target="_blank" rel="noreferrer" className="text-secondary text-decoration-none">linkedin.com/in/jgacosta</a>
          </p>
          <p className="mb-2">
            <span className="fw-bold text-info">GEOGRAPHIC_RED:</span> México (CST)
          </p>
          <p className="mb-2">
            <span className="fw-bold text-info">DIRECT_SIGNAL:</span>{" "}
            <a href="mailto:jacob.gacosta@gmail.com" className="text-success text-decoration-none">jacob.gacosta@gmail.com</a>
          </p>
        </div>
        
        <div className="mt-4 pt-3 border-top border-secondary">
          <p className="small italic text-secondary">
            {note}
          </p>
        </div>
      </div>
    </div>
  );
}

export default DevContact;
